import { render } from "./CrThermographyMore.vue?vue&type=template&id=8d4f60a8&scoped=true"
import script from "./CrThermographyMore.vue?vue&type=script&lang=js"
export * from "./CrThermographyMore.vue?vue&type=script&lang=js"

import "./CrThermographyMore.vue?vue&type=style&index=0&id=8d4f60a8&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4f60a8"]])

export default __exports__